import { space } from '@repo/theme/primitives';

export const FETCH_LINEAGE_BUTTON_OFFSET = `-${space[16]}px`;
export const FETCH_LINEAGE_BUTTON_WIDTH = space[12];

export const FETCH_LINEAGE_BUTTON_LABEL_REF = 'fetch-lineage-button-label';
export const FETCH_LINEAGE_BUTTON_RIGHT_ICON_REF =
	'fetch-lineage-button-right-icon';
